// Action creators for use with Context dispatch

export interface Action {
  type: string;
  payload?: any;
}

export const actions = {
  getMacrosRequest: (payload: { id: string; callConnection: boolean }): Action => ({
    type: 'GET_MACROS_REQUEST',
    payload,
  }),

  getOrgSettingsRequest: (payload: { joid: string }): Action => ({
    type: 'GET_ORG_SETTINGS_REQUEST',
    payload,
  }),

  getIcpByIdRequest: (payload: { icpid: string; joid?: string }): Action => ({
    type: 'GET_ICP_BY_ID_REQUEST',
    payload,
  }),

  getAtsConfigRequest: (payload: { joid?: string }): Action => ({
    type: 'GET_ATS_CONFIG_REQUEST',
    payload,
  }),

  setUser: (payload: any): Action => ({
    type: 'SET_USER',
    payload,
  }),

  setCurrentIcp: (payload: any): Action => ({
    type: 'SET_CURRENT_ICP',
    payload,
  }),

  setAtsConfig: (payload: any): Action => ({
    type: 'SET_ATS_CONFIG',
    payload,
  }),

  setAllMacros: (payload: any[]): Action => ({
    type: 'SET_ALL_MACROS',
    payload,
  }),

  setOrgSettings: (payload: any): Action => ({
    type: 'SET_ORG_SETTINGS',
    payload,
  }),
};

export default actions;
